import { render } from "./radioInput.vue?vue&type=template&id=5be2932e&scoped=true"
import script from "./radioInput.vue?vue&type=script&lang=js"
export * from "./radioInput.vue?vue&type=script&lang=js"

import "./radioInput.vue?vue&type=style&index=0&id=5be2932e&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be2932e"]])

export default __exports__